import React, { useEffect, useState } from 'react';

import { DotLottieReact, setWasmUrl } from '@lottiefiles/dotlottie-react';
import Lottie from 'react-lottie';

setWasmUrl('/dotlottie-player.wasm');

const LottiePlayer = ({ animationData, options, speed = 1 }) => {
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    setHydrated(true);
  }, []);

  if (!hydrated) return null;

  if (typeof animationData === 'string') {
    return <DotLottieReact src={animationData} loop autoplay speed={speed} />;
  }

  return <Lottie options={{ ...options, autoplay: true, animationData }} speed={speed} />;
};

export default React.memo(LottiePlayer);
